import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

// api
import { getMessageToPatientFromAlcohol } from "../../../../services/apis/alcohol/message";

function AlcoholMessage() {
    const { pid } = useParams();
    const [messageData, setMessageData] = useState([]);

    const [searchInput, setSearchInput] = useState("");
    const [searchDate, setSearchDate] = useState({
        start: "",
        end: ""
    })

    const [requestOption, setRequestOption] = useState({
        text: "",
        start: "",
        end: ""
    })


    function convertDate(date) {
        if(!date) return "";

        return date.split('-').join('');
    }

    async function getMessageFromAPI() {
        try {
            const request = {
                pid,
                start: convertDate(requestOption.start),
                end: convertDate(requestOption.end),
                text: requestOption.text
            }
            const res = await getMessageToPatientFromAlcohol(request);
            
            if(parseInt(res.status/200,10)===1){
                setMessageData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
        }
    }

    function handleSearchText() {
        setRequestOption({
            ...requestOption,
            text: searchInput.trim()
        })
    }

    function handleSearchDate() {
        setRequestOption({
            ...requestOption,
            start: searchDate.start,
            end: searchDate.end
        })
    }

    function printDate(date) {
        const dayList = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
        const dateArr = date.split(' ');
        const day = dayList[new Date(dateArr[0]).getDay()];
        return `${dateArr[0]}. ${day}${"\u00A0"}${"\u00A0"}${dateArr[1]}`;
    }


    useEffect(()=>{
        getMessageFromAPI();
    },[requestOption])

    return (
        <div className="patientResult__message">
            <div className="message_row1">
                <div className="row1_header">
                    <div className="header_title">검색 조건</div>
                    <div className="header_button_wrapper">
                        <button
                            type="button"
                            onClick={()=>setSearchInput("")}
                        >초기화</button>
                        <button
                            type="button"
                            onClick={handleSearchText}
                        >검색</button>
                    </div>
                </div>
                <div className="search_input_wrapper">
                    <div className="search_input_label">검색</div>
                    <div className="search_input">
                        <input
                            type="text"
                            maxLength={300}
                            placeholder="내용"
                            value={searchInput}
                            onChange={e=>setSearchInput(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="message_row2">
                <div className="row2_header">
                    <input
                        type="date"
                        value={searchDate.start}
                        onChange={e=>setSearchDate({
                            ...searchDate,
                            start: e.target.value
                        })}
                    />
                    <p className="date_bar">ㅡ</p>
                    <input
                        type="date"
                        value={searchDate.end}
                        onChange={e=>setSearchDate({
                            ...searchDate,
                            end: e.target.value
                        })}
                    />
                    <button
                        className="message_search_button"
                        type="button"
                        onClick={handleSearchDate}
                    >조회</button>
                </div>
                <div className="message_box_list">
                    {messageData.length>0 && messageData.map((item, idx)=> (
                        <div key={idx} className="message_box">
                            <div className="message_box_header">
                                <div className={`message_box_type ${item.noticeType==="private" ? 'private' : ""}`}>{item.noticeType==="private" ? "개인 메시지" : "단체 메시지"}</div>
                                <div className="message_box_date">{printDate(item.receiptDate)}</div>
                            </div>
                            <div className="message_box_content">
                                {item.contents}
                            </div>
                        </div>
                    ))}                    
                </div>
            </div>
        </div>
    );
}

export default AlcoholMessage;